import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Users, Zap, Heart, TrendingUp, MapPin, Briefcase } from 'lucide-react';
import { supabase } from '../lib/supabase';
import './Careers.css';

const Careers = () => {
  const [jobOpenings, setJobOpenings] = useState([]);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        // Try fetching all jobs and filter client-side for case-insensitive status
        const { data, error } = await supabase
          .from('job_openings')
          .select('*')
          .order('created_at', { ascending: false });

        if (!error && data && data.length > 0) {
          // Filter for active status (case-insensitive)
          const activeJobs = data.filter(job => 
            job.status?.toLowerCase() === 'active'
          );
          if (activeJobs.length > 0) {
            setJobOpenings(activeJobs);
            return;
          }
        }
        
        // Try localStorage fallback - check admin_job_openings key
        const stored = localStorage.getItem('admin_job_openings');
        if (stored) {
          const parsed = JSON.parse(stored);
          const activeJobs = parsed.filter(job => job.status?.toLowerCase() === 'active');
          if (activeJobs.length > 0) {
            setJobOpenings(activeJobs);
          }
        }
      } catch (err) {
        console.log('No job openings available:', err);
        // Try localStorage fallback on error
        const stored = localStorage.getItem('admin_job_openings');
        if (stored) {
          const parsed = JSON.parse(stored);
          const activeJobs = parsed.filter(job => job.status?.toLowerCase() === 'active');
          if (activeJobs.length > 0) {
            setJobOpenings(activeJobs);
          }
        }
      }
    };

    fetchJobs();
  }, []);

  const benefits = [
    { icon: <TrendingUp size={32} />, title: 'Growth', description: 'Continuous learning and career advancement opportunities' },
    { icon: <Users size={32} />, title: 'Team', description: 'Work with world-class talent in AI and data science' },
    { icon: <Zap size={32} />, title: 'Impact', description: 'Build technology that transforms decision-making globally' },
    { icon: <Heart size={32} />, title: 'Benefits', description: 'Comprehensive health, wellness, and retirement plans' }
  ];

  return (
    <div className="careers-page">
      <section className="careers-hero">
        <div className="careers-hero-content">
          <p className="careers-hero-label">Careers</p>
          <h1 className="careers-hero-title">Build the Future of Cognitive AI</h1>
          <p className="careers-hero-subtitle">
            Join a team of innovators dedicated to uncovering Absolute Truth and
            transforming how organizations make decisions.
          </p>
        </div>
      </section>

      <section className="careers-benefits">
        <div className="benefits-container">
          <p className="benefits-label">Why Partsol</p>
          <h2 className="benefits-title">More Than Just a Job</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {jobOpenings.length > 0 && (
        <section className="careers-openings">
          <div className="openings-container">
            <p className="openings-label">Open Positions</p>
            <h2 className="openings-title">Current Opportunities</h2>
            <div className="openings-grid">
              {jobOpenings.map((job) => (
                <div key={job.id} className="job-card">
                  <h3 className="job-title">{job.title}</h3>
                  <div className="job-meta">
                    <span className="job-department"><Briefcase size={16} /> {job.department}</span>
                    <span className="job-location"><MapPin size={16} /> {job.location}</span>
                  </div>
                  <p className="job-description">{job.description}</p>
                  <Link to="/contact" className="job-apply-btn">Apply Now</Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="careers-cta">
        <div className="cta-container">
          <h2>Interested in Joining Us?</h2>
          <p>We're always looking for exceptional talent. Send us your resume and let's talk.</p>
          <Link to="/contact" className="cta-button">Get in Touch</Link>
        </div>
      </section>
    </div>
  );
};

export default Careers;
